import React from 'react';

const SkeletonGallery = () => {
    return (
        <div className="skeleton-gallery-wrapper xmt-4">
            <div className="gallery-wrapper d-flex align-items-center">
                <div className="gallery xp-4 br-4 skeleton-loading">
                    <div className="text text--1 skeleton-loading"></div>
                    <div className="text xmt-2 text--2 skeleton-loading"></div>
                </div>
                <div className="gallery xp-4 br-4 skeleton-loading xpx-4">
                    <div className="text text--1 skeleton-loading"></div>
                    <div className="text xmt-2 text--2 skeleton-loading"></div>
                </div>
                <div className="gallery xp-4 br-4 skeleton-loading xpx-4">
                    <div className="text text--1 skeleton-loading"></div>
                    <div className="text xmt-2 text--2 skeleton-loading"></div>
                </div>
            </div>
            <div className="navigation-slider xmt-6">
                <span className="navigation active"></span>
                <span className="navigation"></span>
                <span className="navigation"></span>
            </div>

            <div className="category-slider d-flex align-items-center xmt-6">
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
                <div className="slider xmr-6 d-flex flex-column justify-content-center align-items-center">
                    <div className="image-sk skeleton-loading"></div>
                    <div className="text-sk xmt-4 br-2 skeleton-loading"></div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonGallery;
